import styled from "styled-components";
import { AppBar, Button, Flex, Icon } from "@ebscois/react-component-library";
import { NAV_BREAKPOINT } from "../../utils/constants";

export const StyledHeader = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;

  @media print {
    display: none;
  }
`;

export const StyledAppBar = styled(AppBar.Container)`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    ${({ $isPageScrolled }) => $isPageScrolled && `height: 4rem;`};
  }
`;

export const StyledFlex = styled(Flex)`
  height: 100%;
`;

export const StyleHeaderContent = styled(Flex)`
  flex: 1;
`;

export const StyledHeaderTools = styled(Flex)`
  margin-left: ${({ theme }) => theme.space.lg};

  > *:not(:first-child) {
    margin-left: ${({ theme }) => theme.space.md};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    > *:not(:first-child) {
      margin-left: 0.75rem;
    }

    > *:last-child {
      margin-left: ${({ theme }) => theme.space.sm};
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    > *:not(:first-child) {
      margin-left: ${({ theme }) => theme.space.lg};
    }
  }
`;

const getLogoSize = (logo, size) =>
  logo.height ? `height: ${logo.height[size]}` : `width: ${logo.width[size]}`;

export const StyledHeaderLogo = styled.img`
  vertical-align: middle;
  ${({ $logo }) => getLogoSize($logo, "sm")};

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    ${({ $logo }) => getLogoSize($logo, "md")};
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    ${({ $logo }) => getLogoSize($logo, "lg")};
  }
`;

export const StyledSearchButton = styled(Button.Action)`
  padding: 0;
  height: 1.5rem;
  width: 1.5rem;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    height: 2.125rem;
    width: 2.125rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: none;

    ${({ isHamburgerOpen }) => isHamburgerOpen && `display: block;`};
  }
`;

export const StyledSearchButtonIcon = styled(Icon)`
  pointer-events: none;
`;

export const StyledSearchTray = styled.div`
  padding: 0.75rem ${({ theme }) => theme.space.md};
  background: ${({ theme }) => theme.colors.senary.base};
  ${({ isHidden }) => (isHidden ? `display: none;` : `display: block;`)};
`;

export const StyledDesktopSearchBox = styled.div`
  display: none;
  margin-left: ${({ theme }) => theme.space.lg};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: block;
    max-width: 50rem;
    flex: 1;
  }
`;

export const StyledScrollView = styled.div`
  ${({ isHamburgerOpen }) =>
    isHamburgerOpen &&
    `
    overflow: auto;
    height: calc(100vh - 2.5rem);

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.sm}) {
      height: calc(100vh - 3.75rem);
    }

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
      height: auto;
     }
  `};
`;

export const StyledProductSwitcher = styled.div`
  ${({ isHidden }) => isHidden && `display: none;`};
`;

// Show Hamburger on Mobile/Tablet and Desktop (only when scrolled)
export const StyledHamburgerWrapper = styled.div`
  display: flex;
  margin-right: ${({ theme }) => theme.space.md};
  @media screen and (min-width: ${NAV_BREAKPOINT}) {
    display: none;
    ${({ $isPageScrolled }) => $isPageScrolled && `display: flex;`};
  }
`;
